<template>
  <div class="pt-4">
    <v-card>
      <v-row
        class="
          d-flex
          justify-end
          align-center
          pa-2
        "
        no-gutters
      >
        <v-spacer></v-spacer>

        <v-col cols="12" sm="3">
          <div class="text-right align-end justify-end d-flex">
            <v-text-field
              v-model="searchCampaign"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </div>
        </v-col>
      </v-row>

      <v-data-table
        class="elevation-1"
        :headers="headers"
        :items="listCampaigns"
        :search="searchCampaign"
        :loading="fetchingCampaigns"
        calculate-widths
        :loading-text="$t('loadingData')"
        :no-data-text="$tc('affiliatesCampaigns.noData', statusSelected)"
        :no-results-text="$t('affiliatesCampaigns.noDataFound')"
        :header-props="headerProps"
        :footer-props="{
          'items-per-page-text': $t('rowsPerPage'),
          'items-per-page-options': [5, 10, 15],
        }"
      >
        <template v-slot:[`item.id`]="{ item }">
          <v-btn
            x-small
            @click="$copy(item.id)"
            style="text-transform: none;"
          >
            <span class="text-truncate" style="max-width: 200px;">
              {{ item.id }}
            </span>
          </v-btn>
        </template>

        <template v-slot:[`item.link`]="{ item }">
          <v-btn
            x-small
            @click="$copy(item.link)"
            style="text-transform: none;"
          >
            <span class="text-truncate" style="max-width: 200px;">
              {{ item.link }}
            </span>
          </v-btn>
        </template>

        <template v-slot:[`item.campaign_code`]="{ item }">
          <v-btn x-small @click="$copy(item.campaign_code)">
            {{ item.campaign_code }}
          </v-btn>
        </template>

        <template v-slot:[`item.channel`]="{ item }">
          <div v-if="item.channel" small>
            {{ handleChannelOthers(item.channel) }}
          </div>
          <div v-else>
            ─
          </div>
        </template>

        <template v-slot:[`item.list_adhesions`]="{ item }">
          <Adhesions
            parent="campaigns"
            :campaignId="item.id"
            :showSeeGames="false"
          />
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip small :color="handleStatusUI(item.status).color">
            <span class="white--text">
              {{ handleStatusUI(item.status).text }}
            </span>
          </v-chip>
        </template>

        <template v-slot:[`item.activateOrDesactivate`]="{ item }">
          <v-switch
            v-model="item.status"
            class="mt-n1"
            readonly
            hide-details
            @click="
              openDialogActivateOrDesactivate(
                item.id,
                item.campaign_name,
                item.status
              )
            "
          ></v-switch>
        </template>
      </v-data-table>
    </v-card>

    <DialogActivateOrDesactivateCampaign
      @fetchAffiliateCampaigns="fetchAffiliateCampaigns"
    />
  </div>
</template>

<script>
import DialogActivateOrDesactivateCampaign from "@/components/common/campaigns/DialogActivateOrDesactivateCampaign.vue";
import Adhesions from "@/components/common/adhesions";
// import SeeGames from "./SeeGames.vue"

export default {
  name: "affiliates-campaings",

  components: {
    DialogActivateOrDesactivateCampaign,
    Adhesions
  },

  data: (vm) => ({
    fetchingCampaigns: false,
    searchCampaign: "",
    listCampaigns: [],
    headerProps: {
      sortByText: vm.$t("sortBy"),
    },
    headers: [
      { text: "ID", value: "id", align: "no-wrap", },
      { text: vm.$t("affiliatesCampaigns.name"), value: "campaign_name", align: "no-wrap", },
      { text: vm.$t("affiliatesCampaigns.campaignCode"), value: "campaign_code", align: "no-wrap", },
      { text: "URL", value: "link", },
      { text: vm.$t("affiliatesCampaigns.affiliateName"), value: "affiliate_name", align: "no-wrap", },
      { text: vm.$t("affiliatesCampaigns.createdDate"), value: "created_at", align: "no-wrap", },
      { text: vm.$t("affiliatesCampaigns.updatedDate"), value: "updated_at", align: "no-wrap", },
      // {
      //   text: vm.$t("affiliatesCampaigns.numberOfClicks"),
      //   value: "quantity_link_clicks",
      //   align: "no-wrap",
      // },
      { text: vm.$t("affiliatesCampaigns.numberOfUsers"), value: "quantity_users", align: "no-wrap", },
      ...(vm.$permission("150")
        ? [
            {
              text: vm.$t("registeredUsers"),
              value: "list_adhesions",
              align: "no-wrap",
             },
          ]
        : []),
      { text: vm.$t("affiliatesCampaigns.socialMedia"), value: "channel", align: "no-wrap", },
      { text: "Status", value: "status", align: "no-wrap", },
      ...(vm.$permission("135")
        ? [
            {
              text: vm.$t("affiliatesCampaigns.activateOrDesactivate"),
              value: "activateOrDesactivate",
              align: "no-wrap",
            },
          ]
        : []),
    ],
  }),

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    id_agent() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    statusSelected() {
      return this.$store.state.filters.selectStatus.status;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
  },

  watch: {
    statusSelected() {
      this.listCampaigns = [];
      this.fetchAffiliateCampaigns();
    },
    saveFilters(val) {
      val && this.fetchAffiliateCampaigns();
    },
  },

  methods: {
    fetchAffiliateCampaigns() {
      this.fetchingCampaigns = true;

      const body = {
        regional_id: this.id_regional,
        local_id: this.id_local,
        affiliate_id: this.id_agent,
        status: this.statusSelected,
        start_date: this.rangeDate.data_inicio,
        final_date: this.rangeDate.data_final,
      };

      this.$axios
        .post(
          `${this.$prefix()}/AffiliateCampaign/listAfilliateCampaign`,
          this.$formdata(body)
        )
        .then((resp) => {
          this.listCampaigns = resp.data.dados.map((campaign) => ({
            ...campaign,
            status: Number(campaign.status),
            created_at: campaign.created_at
              ? new Date(
                  campaign.created_at.replace(" ", "T")
                ).toLocaleTimeString([], {
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "",
            updated_at: campaign.updated_at
              ? new Date(
                  campaign.updated_at.replace(" ", "T")
                ).toLocaleTimeString([], {
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "─",
          }));
          this.listCampaigns.reverse();
        })
        .catch(() => {
          this.listCampaigns = [];
        })
        .finally(() => {
          this.fetchingCampaigns = false;
          this.$store.commit("setSave", false);
          this.$store.commit("DisabledSave", false);
        });
    },

    handleStatusUI(status) {
      const statusConfig = {
        0: { text: this.$t("inactive"), color: "blue-grey" },
        1: { text: this.$t("active"), color: "green" },
      };

      return statusConfig[status];
    },
    handleChannelOthers(value) {
      return value == "Others" ? this.$t("affiliatesCampaigns.others") : value;
    },
    openDialogActivateOrDesactivate(idCampaign, nameCampaign, statusCampaign) {
      this.$store.commit("setDialogActivateOrDesactivateCampaign", {
        status: true,
        idCampaign,
        nameCampaign,
        isActivate: !!statusCampaign,
      });
    },
  },
};
</script>
